"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { AuthProvider } from "@/lib/auth";

const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000/api/v1";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60_000,        // 5 minutes before data is considered stale
            gcTime: 10 * 60_000,           // 10 minutes before unused cache is garbage collected
            refetchOnWindowFocus: false,   // Don't refetch when user switches back to tab
            refetchOnReconnect: true,      // Do refetch after network reconnects
            retry: 1,
          },
        },
      })
  );

  // Load brand settings from API and inject CSS variables
  useEffect(() => {
    fetch(`${API_URL}/branding`)
      .then((r) => r.json())
      .then((brand) => {
        const root = document.documentElement;
        if (brand.colors) {
          Object.entries(brand.colors).forEach(([key, value]) => {
            root.style.setProperty(`--color-${key}`, value as string);
          });
        }
        if (brand.fonts) {
          if (brand.fonts.heading)
            root.style.setProperty("--font-heading", brand.fonts.heading);
          if (brand.fonts.body)
            root.style.setProperty("--font-body", brand.fonts.body);
        }
      })
      .catch(() => {
        /* Use CSS defaults if API unavailable */
      });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
